/**
 * Sidebar
 * Sidebar that slides in with content
 * Author: Mayank Gureja
 * Date: 07/04/2019
 * Requires sidebar.scss for styling
 */

const loadingSpinner = '<button class="button is-text is-loading is-centered"><svg class="spinner" viewBox="0 0 50 50"><circle class="ring" cx="25" cy="25" r="20"></circle><circle class="ball" cx="25" cy="5" r="5"></circle></svg></button>';

const openSidebarLoader = (title) => {
  const sidebar = document.querySelector('#sidebar');

  if (title) {
    sidebar.querySelector('.sidebar-header .title').innerHTML = title;
  } else {
    sidebar.querySelector('.sidebar-header .title').innerHTML = loadingSpinner;
  }
  sidebar.querySelector('.sidebar-body .sidebar-content').innerHTML = loadingSpinner;

  sidebar.classList.add('is-active');

  const evt = new CustomEvent('sidebarloading');
  window.dispatchEvent(evt);
};

const openSidebar = (title, content) => {
  const sidebar = document.querySelector('#sidebar');

  if (!title || !content) {
    throw new Error('Sidebar.js: No title or content was passed');
  }

  sidebar.querySelector('.sidebar-header .title').innerHTML = title;
  sidebar.querySelector('.sidebar-body .sidebar-content').innerHTML = content;

  sidebar.classList.add('is-active');

  const evt = new CustomEvent('sidebaropen');
  window.dispatchEvent(evt);
};

const closeSidebar = () => {
  const sidebar = document.querySelector('#sidebar');
  sidebar.classList.remove('is-active');

  const evt = new CustomEvent('sidebarclose');
  window.dispatchEvent(evt);
};

const initSidebar = () => {
  if (!document.querySelector('#sidebar')) {
    const sidebarHtml = `
    <!-- START SIDEBAR -->
    <div id="sidebar" class="sidebar">
        <header class="sidebar-header has-accent">
            <h1 class="title"></h1>
            <span class="icon" onclick="closeSidebar()">
                <i class="fas fa-times fa-lg has-animation-rotate"></i>
            </span>
        </header>

        <div class="sidebar-body">
            <div class="sidebar-block">
                <p class="sidebar-content">
                    ${loadingSpinner}
                </p>
            </div>
        </div>
    </div>
    <!-- END SIDEBAR -->
  `;
    document.querySelector('body').insertAdjacentHTML('beforeend', sidebarHtml);
  }
};

initSidebar();

window.openSidebarLoader = openSidebarLoader;
window.openSidebar = openSidebar;
window.closeSidebar = closeSidebar;
